import React from "react";
import { Link } from "react-router-dom";

// Glossy card shell shared by every home tile: gold gradient border, raised shadow, name on a dark fade, ribbon CTA.
export default function GlossCard({ children, name, ribbon = "Play Now", wide = false, soon = false, light = false, className = "", style, testid, nameTestid, ...rest }) {
  const Tag = rest.to ? Link : rest.onClick ? "button" : "div";
  const props = rest.to ? { to: rest.to } : rest.onClick ? { type: "button", onClick: rest.onClick, disabled: rest.disabled } : {};
  return (
    <Tag {...props} style={style} data-testid={testid} className={`${light ? "bbw-card-light" : "bbw-card"} block w-full text-left ${wide ? "col-span-2" : ""} ${soon ? "opacity-80" : ""} ${className}`}>
      <div className={`bbw-card-in w-full ${wide ? (light ? "aspect-[1.9/1]" : "aspect-[2.3/1]") : "aspect-[4/3]"}`}>
        {children}
        {light && <span className="bbw-glass" />}
        <div className={`${light ? "bbw-name-fade-strong" : "bbw-name-fade"} absolute inset-x-0 bottom-0 h-[52%] pointer-events-none`} />
        <span className={`absolute left-2.5 bottom-2 right-[96px] text-[14px] font-semibold text-white leading-tight ${light ? "line-clamp-2" : "truncate"}`} data-testid={nameTestid}>{name}</span>
        {!soon && ribbon && <span className={`bbw-ribbon ${light ? "bbw-ribbon-light" : ""}`}>{ribbon}</span>}
        <span className="bbw-shine" />
      </div>
    </Tag>
  );
}

